import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../context/LanguageContext';
import { Badge } from '../ui/Badge';

const Row = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: inherit;
  max-width: 100%;

  &:hover {
    opacity: 0.92;
  }
`;

const Thumb = styled.span`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.4rem;
  overflow: hidden;
  flex-shrink: 0;
  background: ${props => props.theme.colors.secondary};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1024px) {
    width: 2rem;
    height: 2rem;
    border-radius: 0.45rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Placeholder = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  color: ${props => props.theme.colors.mutedForeground};
  line-height: 1;
`;

const CategoryBadge = ({
  category,
  color,
  imageUrl,
  slug,
  className,
}) => {
  const { language, getCategoryUrl } = useLanguage();
  const name = typeof category === 'string' ? category : category?.name || '';
  const categorySlug =
    slug ||
    (typeof category === 'object' ? category?.slug : null) ||
    name?.toLowerCase().replace(/\s+/g, '-');
  const src =
    imageUrl ||
    (typeof category === 'object' ? category?.imageUrl : '') ||
    '';

  const badge = (
    <Badge variant={color} className={className}>
      {name}
    </Badge>
  );

  if (!categorySlug) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
        {src ? (
          <Thumb>
            <img src={src} alt="" />
          </Thumb>
        ) : null}
        {badge}
      </span>
    );
  }

  return (
    <Row to={getCategoryUrl(categorySlug, language)} aria-label={name}>
      <Thumb>
        {src ? (
          <img src={src} alt="" />
        ) : (
          <Placeholder>{(name || 'C').charAt(0).toUpperCase()}</Placeholder>
        )}
      </Thumb>
      {badge}
    </Row>
  );
};

export default CategoryBadge;
